var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60851 10.8274H1.35791",
    stroke: "#3b82f6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95068 2.75035H14.2013",
    stroke: "#3b82f6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27207 2.70521C5.27207 1.6255 4.39027 0.75 3.30278 0.75C2.2153 0.75 1.3335 1.6255 1.3335 2.70521C1.3335 3.78492 2.2153 4.66042 3.30278 4.66042C4.39027 4.66042 5.27207 3.78492 5.27207 2.70521Z",
    stroke: "#3b82f6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 10.7948C14.6666 9.7151 13.7855 8.8396 12.698 8.8396C11.6098 8.8396 10.728 9.7151 10.728 10.7948C10.728 11.8745 11.6098 12.75 12.698 12.75C13.7855 12.75 14.6666 11.8745 14.6666 10.7948Z",
    stroke: "#3b82f6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.3308d64df0a84da17354c742339a15e2.svg";
export { ForwardRef as ReactComponent };